export default __webpack_public_path__ + "static/media/nach eil.dd14d43a.mp3";